import Chart from 'chart.js/auto';

window.ChartManager = {
    charts: {},
    init() {
        this.fetchAndRenderBarChart(
            '/admin/deal_ai_match_stats',
            'deal-ai-match-stats-chart'
        );
        this.fetchAndRenderBarChart(
            '/admin/deal_tag_match_stats',
            'deal-tag-match-stats-chart'
        );
        this.fetchAndRenderBarChart(
            '/admin/manual_match_stats',
            'manual-match-stats-chart'
        );

        this.handleDateSelectorChange(
            'deal-ai-match-days-selector',
            'deal-ai-match-team-selector',
            'deal-ai-match-stats-chart',
            '/admin/deal_ai_match_stats'
        );
        this.handleDateSelectorChange(
            'deal-tags-match-days-selector',
            'deal-tags-match-team-selector',
            'deal-tag-match-stats-chart',
            '/admin/deal_tag_match_stats'
        );
        this.handleDateSelectorChange(
            'manual-match-days-selector',
            'manual-match-team-selector',
            'manual-match-stats-chart',
            '/admin/manual_match_stats'
        );

        this.handleTeamSelectorChange(
            'deal-ai-match-team-selector',
            'deal-ai-match-days-selector',
            'deal-ai-match-stats-chart',
            '/admin/deal_ai_match_stats'
        );
        this.handleTeamSelectorChange(
            'deal-tags-match-team-selector',
            'deal-tags-match-days-selector',
            'deal-tag-match-stats-chart',
            '/admin/deal_tag_match_stats'
        );
        this.handleTeamSelectorChange(
            'manual-match-team-selector',
            'manual-match-days-selector',
            'manual-match-stats-chart',
            '/admin/manual_match_stats'
        );

        const startDateSelector = document.getElementById('eoi-stats-start-date');
        const endDateSelector = document.getElementById('eoi-stats-end-date');
        this.fetchEoiStats(
            startDateSelector.getAttribute('data-default-date'),
            endDateSelector.getAttribute('data-default-date')
        );

        this.handleEoiStatsFilterDate(
            'eoi-stats-submit',
            'eoi-stats-start-date',
            'eoi-stats-end-date'
        );

        const incompleteUserStartDateSelector = document.getElementById('new-user-activity-start-date');
        const incompleteUserEndDateSelector = document.getElementById('new-user-activity-end-date');
        this.fetchIncompleteUserStats(
            incompleteUserStartDateSelector.getAttribute('data-default-date'),
            incompleteUserEndDateSelector.getAttribute('data-default-date')
        );

        this.handleIncompleteUserFilterDate(
            'new-user-activity-submit',
            'new-user-activity-start-date',
            'new-user-activity-end-date'
        );
    },

    handleEoiStatsFilterDate(submitButtonId, startDateElementId, endDateElementId) {
        const startDateSelector = document.getElementById(startDateElementId);
        const endDateSelector = document.getElementById(endDateElementId);
        const submitButton = document.getElementById(submitButtonId);

        submitButton.addEventListener('click', (event) => {
            const startDate = startDateSelector.value || startDateSelector.getAttribute('data-default-date');
            const endDate = endDateSelector.value || endDateSelector.getAttribute('data-default-date');

            this.performAjaxCall('/admin/eoi_stats', { start_date: startDate, end_date: endDate} , (data) => {
                this.generate_eoi_stats_table(data);
            });
        });
    },

    handleIncompleteUserFilterDate(submitButtonId, startDateElementId, endDateElementId) {
        const startDateSelector = document.getElementById(startDateElementId);
        const endDateSelector = document.getElementById(endDateElementId);
        const submitButton = document.getElementById(submitButtonId);

        submitButton.addEventListener('click', (event) => {
            const startDate = startDateSelector.value || startDateSelector.getAttribute('data-default-date');
            const endDate = endDateSelector.value || endDateSelector.getAttribute('data-default-date');

            this.performAjaxCall('/admin/new_user_activity_stats', { start_date: startDate, end_date: endDate} , (data) => {
                this.generate_new_user_activity_stats_table(data);
            });
        });
    },

    handleDateSelectorChange(dateElementId, teamElementId, chartElementId, url) {
        const dateSelector = document.getElementById(dateElementId);
        dateSelector.addEventListener('change', (event) => {
            const teamId = parseInt(document.getElementById(teamElementId).value) || null;
            const daysAgo = parseInt(event.target.value);

            this.performAjaxCall(url, { days_ago: daysAgo, team_id: teamId }, (data) => {
                const chart = this.charts[chartElementId];
                if (chart) {
                    chart.data.labels = data.map(row => row.name);
                    chart.data.datasets[0].data = data.map(row => row.total_matches);
                    chart.data.datasets[1].data = data.map(row => row.positive_matches);
                    chart.data.datasets[2].data = data.map(row => row.negative_matches);
                    chart.update();
                }
            });
        });
    },

    handleTeamSelectorChange(teamElementId, dateElementId, chartElementId, url) {
        const teamSelector = document.getElementById(teamElementId);
        teamSelector.addEventListener('change', (event) => {
            const teamId = parseInt(event.target.value) || null;
            const daysAgo = parseInt(document.getElementById(dateElementId).value) || null;

            this.performAjaxCall(url, { days_ago: daysAgo, team_id: teamId }, (data) => {
                const chart = this.charts[chartElementId];
                if (chart) {
                    chart.data.labels = data.map(row => row.name);
                    chart.data.datasets[0].data = data.map(row => row.total_matches);
                    chart.data.datasets[1].data = data.map(row => row.positive_matches);
                    chart.data.datasets[2].data = data.map(row => row.negative_matches);
                    chart.update();
                }
            });
        });
    },

    fetchAndRenderBarChart(url, chartElementId, daysAgo = 30, teamId = null) {
        this.performAjaxCall(url, { days_ago: daysAgo, team_id: teamId }, (data) => {
            const chartElement = document.getElementById(chartElementId);
            this.charts[chartElementId] = this.createBarChart(chartElement, data);
        });
    },

    performAjaxCall(url, params, successCallback) {
        const spinnerElementId = url.includes('deal_ai_match_stats') ? 'deal-ai-match-loader' : 'deal-tags-match-loader';
        const spinnerElement = document.getElementById(spinnerElementId);
        spinnerElement.style.display = 'flex';

        $.ajax({
            url: url,
            type: 'GET',
            data: params,
            success: function (data) {
                successCallback(data);
            },
            failure: function (errMsg) {
                console.log(errMsg);
            },
            complete: function () {
                spinnerElement.style.display = 'none';
            }

        });
    },

    createBarChart(chartElement, data) {
        let delayed;
        return new Chart(chartElement, {
            type: 'bar',
            data: {
                labels: data.map(row => row.name),
                datasets: [
                    {
                        label: 'Total',
                        data: data.map(row => row.total_matches),
                        backgroundColor: '#31B4ED'
                    },
                    {
                        label: 'Positive',
                        data: data.map(row => row.positive_matches),
                        backgroundColor: '#C7EF00'
                    },
                    {
                        label: 'Negative',
                        data: data.map(row => row.negative_matches),
                        backgroundColor: '#ED3131'
                    }
                ]
            },
            animation: {
                onComplete: () => {
                    delayed = true;
                },
                delay: (context) => {
                    let delay = 0;
                    if (context.type === 'data' && context.mode === 'default' && !delayed) {
                        delay = context.dataIndex * 300 + context.datasetIndex * 100;
                    }
                    return delay;
                },
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        labels: {
                            font: {
                                family: 'Montserrat',
                                size: 12,
                            }
                        }
                    }
                }
            }
        });
    },

    fetchEoiStats(startDate, endDate) {
        this.performAjaxCall('/admin/eoi_stats', { start_date: startDate, end_date: endDate }, (data) => {
            this.generate_eoi_stats_table(data);
        });
    },

    generate_eoi_stats_table(data) {
        let table = $('#eoi-stats-table');
        table.find('tr:gt(0)').remove(); // Remove all rows except the first one

        $.each(data.stats, function (index, eoi) {
            let row = $('<tr>');
            row.append($('<th>').html(`<a href="${eoi.path}">${eoi.name}</a>`));
            row.append($('<td>').text(eoi.total));
            row.append($('<td>').text(eoi.accepted));
            row.append($('<td>').text(eoi.match_on_ai));
            row.append($('<td>').text(eoi.match_on_deal_tags));
            row.append($('<td>').text(eoi.match_on_manual));
            row.append($('<td>').text(eoi.unknown));
            row.append($('<td>').text(eoi.rejected));
            row.append($('<td>').text(eoi.time_to_first_eoi !== null ? eoi.time_to_first_eoi : '-'));
            row.append($('<td>').text(eoi.time_to_fifth_eoi !== null ? eoi.time_to_fifth_eoi : '-'));
            row.append($('<td>').text(eoi.present_in_data_system));
            row.append($('<td>').text(eoi.supplier_match_score_difference));
            row.append($('<td>').text(`${eoi.supplier_positive_rating_count} / ${eoi.supplier_negative_rating_count}`));
            row.append($('<td>').text(`${eoi.supplier_positive_rating_percent}% / ${eoi.supplier_negative_rating_percent}%`));
            row.append($('<td>').text(`${eoi.supplier_positive_ai_rating_count} / ${eoi.supplier_negative_ai_rating_count}`));
            row.append($('<td>').text(`${eoi.supplier_positive_ai_rating_percent}% / ${eoi.supplier_negative_ai_rating_percent}%`));
            row.append($('<td>').text(eoi.not_in_data_system));
            row.append($('<td>').text(eoi.country_filter));
            row.append($('<td>').text(eoi.no_products));
            row.append($('<td>').text(eoi.low_match_score));
            row.append($('<td>').text(eoi.translation_issue));
            row.append($('<td>').text(eoi.duplicate_company));
            row.append($('<td>').text(eoi.other_reason));
            row.append($('<td>').text(eoi.status));
            table.append(row);
        });

        let total_row = $('<tr class="border-top">');
        total_row.append($('<th>').text('Totals'));
        total_row.append($('<td>').text(data.totals.total));
        total_row.append($('<td>').text(data.totals.accepted));
        total_row.append($('<td>').text(data.totals.match_on_ai));
        total_row.append($('<td>').text(data.totals.match_on_deal_tags));
        total_row.append($('<td>').text(data.totals.match_on_manual));
        total_row.append($('<td>').text(data.totals.unknown));
        total_row.append($('<td>').text(data.totals.rejected));
        total_row.append($('<td>').text(`avg: ${data.totals.first_eoi_avg}`));
        total_row.append($('<td>').text(`avg: ${data.totals.fifth_eoi_avg}`));
        total_row.append($('<td>').text(data.totals.present_in_data_system));
        total_row.append($('<td>').text(data.totals.supplier_match_score_difference));
        total_row.append($('<td>').text(`${data.totals.supplier_positive_rating_count} / ${data.totals.supplier_negative_rating_count}`));
        total_row.append($('<td>'));
        total_row.append($('<td>').text(`${data.totals.supplier_positive_ai_rating_count} / ${data.totals.supplier_negative_ai_rating_count}`));
        total_row.append($('<td>'));
        total_row.append($('<td>').text(data.totals.not_in_data_system));
        total_row.append($('<td>').text(data.totals.country_filter));
        total_row.append($('<td>').text(data.totals.no_products));
        total_row.append($('<td>').text(data.totals.low_match_score));
        total_row.append($('<td>').text(data.totals.translation_issue));
        total_row.append($('<td>').text(data.totals.duplicate_company));
        total_row.append($('<td>').text(data.totals.other_reason));
        total_row.append($('<td>'));
        table.append(total_row);

        let percent_row = $('<tr class="border-top">');
        percent_row.append($('<th>').text('Percentages'));
        percent_row.append($('<td>').text('-'));
        percent_row.append($('<td>').text(`${data.percentages.accepted} %`));
        percent_row.append($('<td>').text(`${data.percentages.match_on_ai} %`));
        percent_row.append($('<td>').text(`${data.percentages.match_on_deal_tags} %`));
        percent_row.append($('<td>').text(`${data.percentages.match_on_manual} %`));
        percent_row.append($('<td>').text(`${data.percentages.unknown} %`));
        percent_row.append($('<td title="% EOIs that have been rejected">').text(`${data.percentages.rejected} %`));
        percent_row.append($('<td style="white-space:pre;">').text(`${data.percentages.first_eoi_one_day} % \n EOI in 1 day`));
        percent_row.append($('<td style="white-space:pre;">').text(`${data.percentages.fifth_eoi_five_days} % \n 5 EOIs in 4 days`));
        percent_row.append($('<td style="white-space:pre;">').text(`${data.percentages.data_system_hit_rate} % \n AI hit rate`));
        percent_row.append($('<td style="white-space:pre;">').text(`${data.percentages.overall_hit_rate} % \n overall hit rate`));
        percent_row.append($('<td style="white-space:pre;">').text(`${data.percentages.supplier_positive_rating} / ${data.percentages.supplier_negative_rating} % \n Total rating`));
        percent_row.append($('<td>'));
        percent_row.append($('<td style="white-space:pre;">').text(`${data.percentages.supplier_positive_ai_rating} / ${data.percentages.supplier_negative_ai_rating} % \n AI rating`));
        percent_row.append($('<td>'));
        percent_row.append($('<td>').text(`${data.percentages.not_in_data_system} %`));
        percent_row.append($('<td>').text(`${data.percentages.country_filter} %`));
        percent_row.append($('<td>').text(`${data.percentages.no_products} %`));
        percent_row.append($('<td>').text(`${data.percentages.low_match_score} %`));
        percent_row.append($('<td>').text(`${data.percentages.translation_issue} %`));
        percent_row.append($('<td>').text(`${data.percentages.duplicate_company} %`));
        percent_row.append($('<td>').text(`${data.percentages.other_reason} %`));
        percent_row.append($('<td>'));
        table.append(percent_row);
    },

    fetchIncompleteUserStats(startDate, endDate) {
        this.performAjaxCall('/admin/new_user_activity_stats', { start_date: startDate, end_date: endDate }, (data) => {
            this.generate_new_user_activity_stats_table(data);
        });
    },

    generate_new_user_activity_stats_table(data) {
        let table = $('#new-user-activity-table');
        table.find('tr:gt(0)').remove(); // Remove all rows except the first one

        $.each(data.users, function (index, user) {
            let row = $('<tr>');
            row.append($('<th>').html(`<a href="${user.user_path}">${user.user_name}</a>`));
            row.append($('<th>').html(`<a href="${user.company_path}">${user.company_name}</a>`));
            row.append($('<td>').text(user.email));
            row.append($('<td>').text(user.created_at));
            row.append($('<td>').text(user.completed_signup));
            table.append(row);
        });
    },
};
